<form [formGroup]="form" (ngSubmit)="sendLevel()">
  <div class="row">
    <div class="col-2">
      <div class="form-group validateMe">
        <label class="form-label" for="Priority">{{'lang.globals.level' | translate}}</label>
        <input type="number" id="Priority" class="form-control" formControlName="Priority">
        <span class="form-text text-muted">{{'lang.companyLevelEdit.chooseNumber' | translate}}</span>
        <div *ngIf="Priority.touched && Priority.errors?.required"
             class="alert alert-danger">{{'lang.campaignLevelEdit.titleWarning' | translate}}</div>
        <div *ngIf="form.touched && form.errors?.isBetweenNumbers"
             class="alert alert-danger">{{'lang.companyLevelEdit.chooseNumber' | translate}}</div>
      </div>
    </div>
    <!-- <div class="col-5">
      <div class="form-group validateMe">
        <label for="Title" >{{'lang.companyLevelEdit.title' | translate}}</label>
        <input type="text" id="Title" class="form-control" formControlName="Title">
        <div *ngIf="Title.touched && Title.errors?.required" class="alert alert-danger" >{{'lang.campaignLevelEdit.titleWarning' | translate}}</div>
      </div>
    </div>
    <div class="col-5">
      <div class="form-group">
        <label for="Description" >{{'lang.campaignLevelEdit.description' | translate}}</label>
        <input type="text" id="Description" class="form-control" formControlName="Description">
      </div>
    </div>-->
  </div>
  <button class="btn btn-success">{{'lang.globals.submit' | translate}}</button>
</form>
